import { render } from "./ShareOptionsModal.vue?vue&type=template&id=35f120b5&scoped=true"
import script from "./ShareOptionsModal.vue?vue&type=script&lang=js"
export * from "./ShareOptionsModal.vue?vue&type=script&lang=js"

import "./ShareOptionsModal.vue?vue&type=style&index=0&id=35f120b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f120b5"]])

export default __exports__